import React from "react";
import { Grid2 as Grid } from "@mui/material";
import LoginComponent from "../auth/LoginComponent";

const Login = () => {
  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        <LoginComponent />
      </Grid>
    </Grid>
  );
};

export default Login;
